/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */


(function() {
  // Add custom code below this line

  /**
   * Per-Variant Pre-Order Badge Logic
   *
   * Problem: The pre-order badge, icon block, and button text are set at
   * product level in Liquid (server-side). When a product has some in-stock
   * variants and some pre-order variants, the badge incorrectly shows for
   * all variants.
   *
   * Fix: We build a list of "true pre-order" variant IDs server-side (those
   * with inventory_policy='continue' AND inventory_quantity<=0), store them
   * in a data attribute, then use the theme:variant:change event to
   * dynamically show/hide the badge, icon, and update button text.
   */

  function initPreorderVariantBadge() {
    const productSections = document.querySelectorAll('[data-section-type="product"][data-preorder-variant-ids]');

    productSections.forEach(function(section) {
      // Parse the list of pre-order variant IDs stored in the data attribute
      let preorderVariantIds = [];
      let mercantilePreorderVariantIds = [];
      try {
        const raw = section.getAttribute('data-preorder-variant-ids');
        preorderVariantIds = JSON.parse(raw || '[]');
        
        const rawMercantile = section.getAttribute('data-mercantile-preorder-variant-ids');
        mercantilePreorderVariantIds = JSON.parse(rawMercantile || '[]');
      } catch (e) {
        console.warn('[PreorderBadge] Could not parse preorder variant IDs', e);
        return;
      }

      const isProductPreorder = section.getAttribute('data-product-is-preorder') === 'true';

      // If this product doesn't use pre-order or mercantile preorder at all, skip
      if (!isProductPreorder && preorderVariantIds.length === 0 && mercantilePreorderVariantIds.length === 0) {
        return;
      }

      // Listen to the theme's variant change event
      section.addEventListener('theme:variant:change', function(event) {
        const variant = event.detail && event.detail.variant;
        if (!variant) return;

        // A variant is "pre-order" if it's in our server-built list of
        // variants with continue policy + no stock
        const isPreorderVariant = preorderVariantIds.includes(variant.id);
        const isMercantilePreorderVariant = mercantilePreorderVariantIds.includes(variant.id);

        updatePreorderBadge(section, isPreorderVariant, isMercantilePreorderVariant, variant);
      });
    });
  }

  function updatePreorderBadge(section, isPreorderVariant, isMercantilePreorderVariant, variant) {
    // Check for the product ID at the beginning of the function
    const w3ProductOptions = section.querySelector('.w3-product-options');
    const productId = w3ProductOptions ? w3ProductOptions.getAttribute('data-product-id') : null;

    // 0. Mercantile Badge vs Default Badges
    const mercantileBadge = section.querySelector('[data-mercantile-badge]');
    const defaultBadges = section.querySelector('[data-default-badges]');
    
    if (mercantileBadge) {
      mercantileBadge.style.display = isMercantilePreorderVariant ? '' : 'none';
    }
    
    if (defaultBadges) {
      defaultBadges.style.display = isMercantilePreorderVariant ? 'none' : '';
    }

    // 1. Pre-order badge span
    const badge = section.querySelector('[data-preorder-badge]');
    if (badge) {
      badge.style.display = isPreorderVariant ? '' : 'none';
    }

    // 2. Pre-order icon block
    const iconBlock = section.querySelector('[data-preorder-icon-block]');
    if (iconBlock) {
      iconBlock.style.display = isPreorderVariant ? '' : 'none';
    }

    // 3. Add-to-cart button text
    // We added the productId check here to prevent the main button from changing
    const atcTextEl = section.querySelector('[data-add-to-cart-text]');
    if (atcTextEl && productId !== '795193665') {
      if (isPreorderVariant) {
        // Pre-order: variant is purchasable via continue policy
        const preorderText = window.theme && window.theme.strings && window.theme.strings.preOrder
          ? window.theme.strings.preOrder
          : 'Pre-order';
        atcTextEl.textContent = preorderText;
      } else if (variant.available) {
        // In stock: show normal add to cart
        const addToCartText = window.theme && window.theme.strings && window.theme.strings.addToCart
          ? window.theme.strings.addToCart
          : 'Add to Cart';
        atcTextEl.textContent = addToCartText;
      }
      // If not available and not pre-order, the theme handles "Sold Out" text itself
    }
    
    // 4. The cart-bar button text (used in sticky add-to-cart bar)
    if (productId !== '795193665') {
      const cartBarTextEl = section.querySelector('[data-add-to-cart-bar] .btn__text');
      if (cartBarTextEl && variant.available !== false) {
        if (isPreorderVariant) {
          const preorderText = window.theme && window.theme.strings && window.theme.strings.preOrder
            ? window.theme.strings.preOrder
            : 'Pre-order';
          cartBarTextEl.textContent = preorderText;
        } else {
          const addToCartText = window.theme && window.theme.strings && window.theme.strings.addToCart
            ? window.theme.strings.addToCart
            : 'Add to Cart';
          cartBarTextEl.textContent = addToCartText;
        }
      }
    }
  }

  // Initialize after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreorderVariantBadge);
  } else {
    initPreorderVariantBadge();
  }

  // Also re-initialize when Shopify theme editor reloads a section
  document.addEventListener('shopify:section:load', function() {
    initPreorderVariantBadge();
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();